export const CONSULTANT_INFO_STORAGE_KEY = 'consultantInfo'
export const CONSULTANT_ZIP_OVERRIDE_KEY = 'consultantZipOverride'

const isBrowser = () => typeof window !== 'undefined'

export const normalizeConsultantZip = (value = '') =>
  String(value || '').replace(/\D/g, '').slice(0, 5)

export const getStoredConsultantInfo = () => {
  if (!isBrowser()) return null
  try {
    const raw = window.sessionStorage.getItem(CONSULTANT_INFO_STORAGE_KEY)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

export const saveStoredConsultantInfo = (data) => {
  if (!isBrowser()) return
  try {
    if (data) {
      window.sessionStorage.setItem(CONSULTANT_INFO_STORAGE_KEY, JSON.stringify(data))
    } else {
      window.sessionStorage.removeItem(CONSULTANT_INFO_STORAGE_KEY)
    }
  } catch {
    /* no-op */
  }
}

export const clearStoredConsultantInfo = () => {
  saveStoredConsultantInfo(null)
}

export const markConsultantZipOverride = (zip = '') => {
  if (!isBrowser()) return
  try {
    window.sessionStorage.setItem(CONSULTANT_ZIP_OVERRIDE_KEY, normalizeConsultantZip(zip) || 'manual')
  } catch {
    /* no-op */
  }
}

export const hasConsultantZipOverride = () => {
  if (!isBrowser()) return false
  try {
    return Boolean(window.sessionStorage.getItem(CONSULTANT_ZIP_OVERRIDE_KEY))
  } catch {
    return false
  }
}

export const clearConsultantZipOverride = () => {
  if (!isBrowser()) return
  try {
    window.sessionStorage.removeItem(CONSULTANT_ZIP_OVERRIDE_KEY)
  } catch {
    /* no-op */
  }
}

export const clearConsultantSession = () => {
  clearStoredConsultantInfo()
  clearConsultantZipOverride()
}

export const dispatchConsultantInfoChange = (data) => {
  if (typeof document === 'undefined') return
  document.dispatchEvent(new CustomEvent('zipcodeSent', { detail: data || null }))
}
